import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

// router
import { RouterEffects } from './router/store/effects';
import { CustomRouterStateSerializer, FEATURE_NAME as routerFeature } from './router/store/state';
// auth
import { reducers as authReducers } from './auth/store';
import { AuthEffects } from './auth/store/effects';
import { FEATURE_NAME as authFeature } from './auth/store/state';
// context-menu
import { reducers as contextMenuReducers } from './context-menu/store';
import { ContextMenusEffects } from './context-menu/store/effects';
import { FEATURE_NAME as contextMenuFeature } from './context-menu/store/state';
// engine-customizations
import { reducers as customizationsReducers } from './engine-customizations/store';
import { CustomizationsEffects } from './engine-customizations/store/effects';
import { FEATURE_NAME as customizationsFeature } from './engine-customizations/store/state';
// engine-forms
import { reducers as formsReducers } from './engine-forms/store';
import { FormEffects } from './engine-forms/store/effects';
import { FEATURE_NAME as formsFeature } from './engine-forms/store/state';
// engine-processes
import { reducers as processesReducers } from './engine-processes/store';
import { ProcessEffects } from './engine-processes/store/effects';
import { FEATURE_NAME as processesFeature } from './engine-processes/store/state';
// engine-views
import { reducers as viewsReducers } from './engine-views/store';
import { ViewEffects } from './engine-views/store/effects';
import { FEATURE_NAME as viewsFeature } from './engine-views/store/state';
// errors
import { reducers as errorsReducers } from './errors/store';
import { ErrorEffects } from './errors/store/effects';
import { FEATURE_NAME as errorsFeature } from './errors/store/state';
// layout
import { reducers as layoutReducers } from './layout/store';
import { LayoutEffects } from './layout/store/effects';
import { FEATURE_NAME as layoutFeature } from './layout/store/state';
// menu
import { reducers as menuReducers } from './menu/store';
import { MenuEffects } from './menu/store/effects';
import { FEATURE_NAME as menuFeature } from './menu/store/state';
// navigation
import { reducers as navigationReducers } from './navigation/store';
import { LayoutEffects as NavigationEffects } from './navigation/store/effects';
import { FEATURE_NAME as navigationFeature } from './navigation/store/state';
// notification
import { reducers as notificationReducers } from './notification/store';
import { FEATURE_NAME as notificationFeature } from './notification/store/state';
// user
import { reducers as userReducers } from './user/store';
import { UserEffects } from './user/store/effects';
import { FEATURE_NAME as userFeature } from './user/store/state';
// blob
import { BlobEffects } from './blob/store/effects';
import { blobReducer } from './blob/store/reducers';
import { FEATURE_NAME as blobFeature } from './blob/store/state';

export function provideAppStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore(),
    provideEffects(),
    provideStoreDevtools({ maxAge: 50, logOnly: environment.production }),
    provideRouterStore({ serializer: CustomRouterStateSerializer }),

    provideState(routerFeature, routerReducer),
    provideEffects(RouterEffects),

    provideState(authFeature, authReducers),
    provideEffects(AuthEffects),

    provideState(contextMenuFeature, contextMenuReducers),
    provideEffects(ContextMenusEffects),

    provideState(customizationsFeature, customizationsReducers),
    provideEffects(CustomizationsEffects),

    provideState(formsFeature, formsReducers),
    provideEffects(FormEffects),

    provideState(processesFeature, processesReducers),
    provideEffects(ProcessEffects),

    provideState(viewsFeature, viewsReducers),
    provideEffects(ViewEffects),

    provideState(errorsFeature, errorsReducers),
    provideEffects(ErrorEffects),

    provideState(layoutFeature, layoutReducers),
    provideEffects(LayoutEffects),

    provideState(menuFeature, menuReducers),
    provideEffects(MenuEffects),

    provideState(navigationFeature, navigationReducers),
    provideEffects(NavigationEffects),

    provideState(notificationFeature, notificationReducers),

    provideState(userFeature, userReducers),
    provideEffects(UserEffects),

    provideState(blobFeature, blobReducer),
    provideEffects(BlobEffects),
  ]);
}
